jQuery(document).ready(function ($) {
  $('.accordion__group').removeClass('active');
  $('.accordion__group').find('.accordion__copy').slideUp(); // Simple accordion functionality

  $('.accordion__group button').on('click', function (e) {
    e.preventDefault(); // If item clicked on is open, close it

    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  // Simple quantity box increase / decrease
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  // PDP Options active class
  //$( '.pdp__options button' ).on( 'click', function( e ) {
  //  e.preventDefault();
  //   $( this ).closest( '.option__wrap' ).find( 'button' ).removeClass( 'active' );
  //   $( this ).addClass( 'active' );
  // } );
  // Content Grid Modal
  $(".modal-button").each(function (index) {
    var image = $(this).attr("data-image");
    preloadImage(image);
  }); // On pageload makesure it's closed

  $('.content-modal').hide(); // When the user clicks on the button, open the modal

  $('.modal-button').on('click', function (e) {
    $('.content-modal').fadeIn("fast");
    var title = $(this).attr("data-title");
    var subtitle = $(this).attr("data-subtitle");
    var image = $(this).attr("data-image");
    var content = $(this).attr("data-content");
    var linkText = $(this).attr("data-link-text");
    var linkUrl = $(this).attr("data-link-url");
    var linkTarget = $(this).attr("data-link-target");
    var facebook = $(this).attr("data-facebook");
    var instagram = $(this).attr("data-instagram");
    var linkedin = $(this).attr("data-linkedin");
    populateModal(title, subtitle, image, content, linkText, linkUrl, linkTarget, facebook, instagram, linkedin);
  }); // When the user clicks on the x, close the modal

  $('.close-content-modal, .content-modal:not(.inner)').on('click', function (e) {
    $('.content-modal').fadeOut('fast');
  }); // Video Modal
  // On pageload makesure it's closed

  $('#videoModal').hide(); // When the user clicks on the button, open the modal

  $('#play-icon').on('click', function (e) {
    $('#videoModal').fadeIn("fast");
    var video = $(this).attr("data-video");
    var source = $(this).attr("data-source");
    populateVideoModal(video, source);
  }); // When the user clicks on the x, close the modal

  $('#close-button').on('click', function (e) {
    $('#videoModal').fadeOut('fast');
    $('#youtubePlayer iframe').attr('data-src', 'VIDEOID');
  });
});

function populateModal(title, subtitle, image, content, linkText, linkUrl, linkTarget, facebook, instagram, linkedin) {
  $('.modal-title').text(title);
  $('.modal-subtitle').text(subtitle);
  $('.modal-image').attr('src', image);
  $('.modal-image').attr('alt', title);
  $('.modal-content').html(content);
  $('.modal-link').text(linkText);
  $('.modal-link').attr('href', linkUrl);

  if (linkTarget == true) {
    $('.modal-link').attr('target', "_blank");
  } //$('.modal-facebook').attr('href', facebook);
  //$('.modal-instagram').attr('href', instagram);
  //$('.modal-linkedin').attr('href', linkedin);
  // console.log("populated");

}

function preloadImage(url) {
  var img = new Image();
  img.src = url;
}

function populateVideoModal(video, source) {
  if (source == "youtube") {
    var videoURL = "https://www.youtube.com/embed/" + video;
    $('#youtubePlayer').css('display', "block");
    $('#youtubePlayer iframe').attr('data-src', videoURL);
  } else {
    var videoURL = "https://player.vimeo.com/video/VIDEOID" + video + "?h=4035a1897c&title=0&byline=0&portrait=0";
    $('#vimeoPlayer').css('display', "block");
    $('#vimeoPlayer iframe').attr('data-src', linkUrl);
  } // console.log("populated video modal");

}
jQuery(document).ready(function ($) {
  $('.alert-bar__slider').slick({
    infinite: true,
    slideToShow: 1,
    vertical: true,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 5500
  });
  $('#menu-icon').on('click', function () {
    if ($('.mega-menu').css('display') == "none") {
      $('.mega-menu').fadeIn(200);
      $('.fixed-wrap').addClass('scrolling');
      $('#menu-icon').addClass('is-active');
    } else {
      $('#menu-icon').removeClass('is-active');
      $('.mega-menu').fadeOut(100);

      if ($(window).scrollTop() <= 350) {
        $('.fixed-wrap').removeClass('scrolling');
      }
    }
  });
  headerOffset(); // Update offset on scroll

  $(window).on('scroll resize', function () {
    headerOffset();
  }); // Update offset on alert bar close

  $('.alert-bar .close--alert').on('click', function () {
    $('.alert-bar').remove();
    headerOffset();
  }); // Offset content from fixed header

  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    var subtractHeight = headerHeight - $('.header').innerHeight();
    $('#main').css('padding-top', subtractHeight + 'px');
    $('.mega-menu').css('top', headerHeight - 1);
    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();

      if ($(window).scrollTop() >= 350) {
        $('.fixed-wrap').addClass('scrolling');

        if (newsHeight != undefined) {
          $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)'); // $( '.mega-menu' ).css( 'top', newsHeight+'px' );
        }
      } else {
        if ($('.mega-menu').css('display') == "none") {
          $('.fixed-wrap').removeClass('scrolling');
        }

        $('.fixed-wrap').css('transform', 'translateY(0)'); // $( '.mobile-menu' ).css( 'margin-top', '0' );
        // $( '.mini-cart' ).css( 'margin-top', '0' );
      }
    });
  }
});
jQuery(document).ready(function ($) {
  // Hero--full Slider
  $('.hero--full .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // Hero--split Slider

  $('.hero--split .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // Hero--split-flip Slider

  $('.hero--split-flip .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split-flip .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // PDP Default image slider

  $('.pdp__images--default .pdp__slider--thumb').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    vertical: true,
    focusOnSelect: true,
    asNavFor: '.pdp__images--default .pdp__slider--main',
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        vertical: false
      }
    }]
  });
  $('.pdp__images--default .pdp__slider--main').slick({
    infinite: true,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.pdp__images--default .pdp__slider--thumb'
  }); // Video Slider

  $('.video__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: true
      }
    }]
  }); // Impact Slider and Progress Bar

  var $slider = $('.impact__slider');
  var $progressBar = $('.impact_progress');
  var $progressBarLabel = $('.impact_slider__label');
  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var calc = nextSlide / (slick.slideCount - 1) * 100;
    $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
    $progressBarLabel.text(calc + '% completed');
  });
  $('.impact__slider').slick({
    fade: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        arrows: true
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        arrows: true
      }
    }, {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        arrows: true
      }
    }]
  });
});
// Timeline
jQuery(document).ready(function ($) {
  var year = $('.timeline-bar .year-button.active').attr("data-year");
  var content = $('.timeline-bar .year-button.active').attr("data-content");
  var image = $('.timeline-bar .year-button.active').attr("data-image");
  var alt = $('.timeline-bar .year-button.active').attr("data-alt");
  populateTimeline(year, content, image, alt);
  $(".timeline-bar .year-button").each(function (index) {
    var image = $(this).attr("data-image");
    preloadImage(image);
  });
  $('.timeline-bar .year-button').on('click', function (e) {
    e.preventDefault();
    var year = $(this).attr("data-year");
    var content = $(this).attr("data-content");
    var image = $(this).attr("data-image");
    var alt = $(this).attr("data-alt");
    populateTimeline(year, content, image, alt); // If item clicked on is open, close it

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.timeline-bar .year-button').removeClass('active');
      $(this).closest('.timeline-bar .year-button').addClass('active');
    }
  });
});

function populateTimeline(year, content, image, alt) {
  $('.year-year').text(year);
  $('.year-image').attr('src', image);
  $('.year-image').attr('alt', alt);
  $('.year-content').html(content);
  console.log("populated");
}
// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 
console.log("This site was developed by https://www.sleeplessmedia.com");

(function ($) {})(jQuery);
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.